import PgHeroHome from "../../../../content/articles/2014-12-15-postgres-insights-pghero/pghero-home.png";
import PgHeroIndex from "../../../../content/articles/2014-12-15-postgres-insights-pghero/pghero-index.png";
import React from 'react';
export default {
  PgHeroHome,
  PgHeroIndex,
  React
};